import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Button } from "@mui/material";
import FileDropzone from "../../components/FileDropzone";

const UploadDocumentsModal = ({
  scroll,
  currentReqDetails,
  currentReqID,
  setRequirementsDocuments,
  requirementsDocuments,
  setOpenDocumentsModal,
  openDocumentsModal,
}) => {
  const [files, setFiles] = useState([]);
  const handleCloseDocumentsDialog = () => {
    setOpenDocumentsModal(false);
  };

  const handleUploadButton = () => {
    // console.log("Current Req ID: ", currentReqID);
    // Loop through the files and append currentReqID to the begining of each file name
    let newFiles = [];
    files.forEach((file) => {
      let newFile = new File([file], currentReqID + "_" + file.name, {
        type: file.type,
      });
      newFiles.push(newFile);
    });

    // add the newFiles with setRequirementsDocuments
    setRequirementsDocuments({
      ...requirementsDocuments,
      [currentReqID]: newFiles,
    });
    // console.log("Req Images: ", requirementsDocuments);

    setOpenDocumentsModal(false);
  };

  return (
    <div>
      {/* W O R K    T O    B E    D O N E */}
      {/* ************************************************* Upload Images Dialog********************************************** */}
      <Dialog
        open={openDocumentsModal}
        onClose={handleCloseDocumentsDialog}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          <Typography
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Upload documents for the following requirement
          </Typography>
        </DialogTitle>
        <DialogContent dividers={true}>
          {currentReqDetails}
          <FileDropzone
            setFiles={setFiles}
            acceptedFiles={[
              "image/jpeg",
              "image/png",
              "image/bmp",
              "application/pdf",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ]}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCloseDocumentsDialog}
          >
            Close
          </Button>
          <Button
            variant="outlined"
            onClick={handleUploadButton}
            // disabled={!termsChecked}
            color="success"
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/*E N D    W O R K    T O    B E    D O N E */}
    </div>
  );
};

export default UploadDocumentsModal;
